export class VideoConfigurationBlockedError extends Error {
  constructor(message?: string) {
    super(message ?? 'Cannot configure video while the courtroom has an active recording or session.')
    Object.setPrototypeOf(this, VideoConfigurationBlockedError.prototype)
  }
}
